<template>
    <div class="mobile-nav-panel" v-if="Object.keys(contactsContent).length">
        <div class="btn-group">
            <a :href="'tg://resolve?domain=' + contactsContent.socials.list.telegram" class="panel-btn telegram btn-telegram" target="_blank">
                <span class="btn-icon fab fa-telegram"></span>
            </a>
            <a :href="'viber://chat/?number=' + contactsContent.socials.list.viber" class="panel-btn viber btn-viber" target="_blank">
                <span class="btn-icon fab fa-viber"></span>
            </a>
            <a :href="'https://wa.me/' + contactsContent.socials.list.whatsapp" class="panel-btn whatsapp btn-whatsapp" target="_blank">
                <span class="btn-icon fab fa-whatsapp"></span>
            </a>
            <a @click="scrollToSubmitForm()" class="panel-btn">
                <span class="btn-text">{{ btnText[lang] }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            btnText: {
                ua: 'Залишити заявку або придбати онлайн',
                ru: 'Оставить заявку или купить онлайн',
                en: 'Leave request or buy online'
            }
        }
    },
    props: {

    },
    methods: {
        scrollToSubmitForm() {
            if (this.$route.path.split('/').length > 2 && this.$route.path.split('/')[1] == 'courses') {
                document.querySelector('#courseSubmitForm').scrollIntoView({
                    behavior: 'smooth'
                });
            } else {
                this.$router.push('/courses');
            }
        }
    },
    computed: {
        lang() {
            return this.$store.getters['getSelectedLang'];
        },
        contactsContent() {
            return this.$store.getters['getContactsPageContent'];
        }
    }
}
</script>
